module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionPermissionModal",
    attrs: {
      "id": "missionPermissionModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.permission'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionPermissions
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.permission.existing')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('mission-permissions', {
    attrs: {
      "missionPermissions": _vm.missionPermissions
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-bold"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_vm._v(_vm._s(_vm.$t('mission.permission.add')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionPermission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.permission.user.selection'),
      "state": _vm.missionPermissionAddUserState,
      "description": _vm.$t('mission.permission.user.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionPermissionAddUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.permissionUserSelected
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.permission.permission'),
      "state": _vm.missionPermissionAddPermissionState,
      "description": _vm.$t('mission.permission.permission.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionPermissionAddPermissionOptions
    },
    model: {
      value: (_vm.missionPermissionAdd.permission),
      callback: function($$v) {
        _vm.missionPermissionAdd.permission = $$v
      },
      expression: "missionPermissionAdd.permission"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('notification.suppress'),
      "state": "success",
      "description": _vm.$t('notification.suppress.description')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: (_vm.missionPermissionAddSuppressNotifications),
      callback: function($$v) {
        _vm.missionPermissionAddSuppressNotifications = $$v
      },
      expression: "missionPermissionAddSuppressNotifications"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionPermission
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add.mission.permission')) + "\n                ")])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission permission actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionPermissionModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03756c57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionPermissionModal.vue
// module id = 466
// module chunks = 0